// 引入和配置 axios
import axios from "axios";
import store from "@/store/index"
import router from "@/router/index"
var element = require('element-ui')
import {
	MessageBox
} from 'element-ui'
import {
	Loading
} from 'element-ui';
// axios.defaults.withCredentials = true; //跨域访问需要发送cookie时使用

if (localStorage.getItem('token')) {
	var header = {
		"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
		"Accept-Language": store.state.lang, //中英文请求头，中文：zh;英文：en
		"Authorization_Api": localStorage.getItem('token')
	}
} else {
	var header = {
		"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
		"Accept-Language": store.state.lang, //中英文请求头，中文：zh;英文：en
	}
}
// let loadingInstance = Loading.service({
// 			background: 'rgba(0, 0, 0, 0.3)'
// 		})
let instance = axios.create({
	baseUrl: '/api',
	timeout: 30000,
	withCredentials: false, // 不携带cookie
})
instance.interceptors.request.use(
	config => {
		let header = {
			"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
			"Accept-Language": store.state.lang, //中英文请求头，中文：zh;英文：en
		}
		//请求地址 ---是否携带token
		if (config.url.indexOf('/api/') !== -1&& store.state.isLogin) {
			const token = store.state.token
			if (token) {
				header['Authorization_Api'] = token
			}
			config.headers = header
		}
		//单独接口表单形式传值
		if (config.url.indexOf('/postUserExamInfo') !== -1) {
			header['Content-Type'] = 'application/json'
			config.headers = header
			if (store.state.userInfo) {
				config.data.userId = store.state.userInfo.id
			}
		}

		if (config.url.substr(config.url.length - 2, 2) === '-0') {
			config.url = config.url.substring(0, config.url.length - 2);
			// console.log(config.params, "不用传userId")
		} else {
			if (config.method === 'get' && store.state.userInfo) {
				config.params.userId = store.state.userInfo.id
			}
		}
		return config // 对config处理完后返回，下一步将向后端发送请求
	},

	error => { // 当发生错误时，执行该部分代码
		console.log(error, 'error'); //调试用
		return Promise.reject(error)
	}
)
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	if (response.status == 200) {
	}
	if (response.data.code === 1009 || response.data.code === 401) {
		MessageBox.confirm('登录失效，请重新登录', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			store.state.isLogin = false
			localStorage.setItem('isLogin', false)
			router.push('/login')
		}).catch(() => {
			router.back(-1)
		});
	}
	if (response.data.code === 1010) {
		MessageBox.confirm('您的账号在其他设备登录', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			store.state.isLogin = false
			localStorage.setItem('isLogin', false)
			router.push('/login')
		}).catch(() => {
			router.back(-1)
		});
	}

	if (response.data.code === 500) {
		console.log(response.data.msg)
		element.Message({
			message: response.data.msg,
			type: 'error'
		})

	}
	return response.data;
}, function (error) {
	// 对响应错误做点什么
	// alert('出错了')
	return Promise.reject(error);
});

export {
	instance
}



// WEBPACK FOOTER //
// ./src/api/index.js